"use client"
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import React from "react";
import CountriesSelect, { CountriesType } from "./components/CountrySelected/CountrySelected";
import { useIsCountryMatch } from "../../hooks/useCountrySelected";
import useCities from "../../hooks/useCities";
import { Link, useParams } from "react-router-dom";
import { AppStore } from "../../redux/store";
import { isLoggedIn } from "../../helpers/authHelper";
import { toogleAction } from "../../redux/features/navigation";
import ItemNavMobile from "./components/ItemNavMobile/ItemNavMobile";


type IModalProps = {
  onAction: React.MouseEventHandler<HTMLButtonElement> | undefined;
  isDark?: boolean;
  countries: CountriesType[];
};

const MobileMenu: React.FC<IModalProps> = ({ isDark = false, countries }) => {
  const isCountryMatch = useIsCountryMatch();

  const { cities, citiesBuy } = useCities();
  const { id = "", code } = useParams();
  const { country } = useSelector((store: AppStore) => store.country);
  const dispatch = useDispatch();
  const user = useSelector((store: AppStore) => store.auth);
  const isLogged = isLoggedIn(user);

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    if (isLogged) {
      dispatch(toogleAction(true));
    } else {
      dispatch(toogleAction(false));
    }
  }, []);


  const OptionPropietario: any = [{
    name: 'Vender mi propiedad',
    link: `/${country}/venta/vender-casa-apartamento-con-propi`
  }, {
    name: 'Rentar mi propiedad',
    link: `/${country}/alquiler/alquila-tu-casa-apartamento-con-propi`,
  }]

  const OptionCalcula = [
    {
      name: "Calculadora de crédito hipotecario",
      link: `/${country}/venta/calculadora-credito-hipotecario`,
    },
    ...(isCountryMatch
      ? [
        {
          name: "Calculadora de renta",
          link: `/${country}/alquila-casa-apartamento-en-propi#calculadora`,
        },
      ]
      : []),
  ];


  const OptionPropi: any = [
    {
      name: "Ayuda",
      link: `/${country}/ayuda`,
    },
    {
      name: "¿Quienes somos?",
      link: `/${country}/quienes-somos`,
    },
    {
      name: "Refiere y gana",
      link: `/app/${country}/referidos`,
    },
    {
      name: "Blog",
      link: `https://blog.propilatam.com/`,
    },
  ];
  return (
    <>
      <div className=" top-0 bottom-0 w-full h-full bg-[#092417] rounded-l-2xl" style={{ zIndex: '1000' }}>
        <div className="container px-6 h-full pt-10 pb-10 overflow-y-auto">
          <ul className="flex flex-col gap-3">
            {
              isCountryMatch && <li className="w-full">
                <ItemNavMobile title="Alquilar">
                  {cities?.map((city, index) => (
                    <li key={`city-${index}`}>
                      <ItemNavMobile title={city.name} level={2}>
                        <ul className="flex flex-col justify-end">
                          {city.properties.map((property, propIndex) => (
                            <Link
                              key={`prop-${propIndex}`}
                              className="text-[#fff] text-sm mt-2 pl-4 text-right "
                              to={property.url || '#'}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {property.name}
                            </Link>
                          ))}
                        </ul>
                      </ItemNavMobile>
                    </li>
                  ))}

                </ItemNavMobile>
              </li>
            }

            <li className="flex items-center justify-end">
              <ItemNavMobile title="Comprar">
                {citiesBuy?.map((city, index) => (
                  <li key={`city-${index}`}>
                    <ItemNavMobile title={city.name} level={2}>
                      <ul className="flex flex-col justify-end">
                        {city.properties.map((property, propIndex) => (
                          <a
                            key={`prop-${propIndex}`}
                            className="text-[#fff] text-sm mt-2 pl-4 text-right "
                            href={property.url || '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {property.name}
                          </a>
                        ))}
                      </ul>
                    </ItemNavMobile>
                  </li>
                ))}

              </ItemNavMobile>
            </li>
            {
              isCountryMatch && <li className="w-full">
                <ItemNavMobile title="Propietarios">
                  <ul className="flex flex-col justify-end">
                    {OptionPropietario.length > 0 &&
                      OptionPropietario?.map((item: any, index: number) => (
                        <Link key={index} className="text-[#fff] text-sm mt-2 text-right" to={item?.link}>
                          {item?.name}
                        </Link>
                      ))}
                  </ul>
                </ItemNavMobile>
              </li>
            }

            <li className="flex items-center justify-end">
              <ItemNavMobile title="Simula y Calcula">
                <ul className="flex flex-col justify-end">
                  {OptionCalcula.length > 0 &&
                    OptionCalcula?.map((item: any, index: number) => (
                      <a
                        key={index}
                        className="text-[#fff] text-sm mt-2 text-right"
                        href={item?.link}
                      >
                        {item?.name}
                      </a>
                    ))}
                </ul>
              </ItemNavMobile>
            </li>
            <li className="w-full flex justify-end">
              <ItemNavMobile title="Más de Propi">
                <ul className="flex flex-col justify-end">
                  {OptionPropi.length > 0 &&
                    OptionPropi?.map((item: any, index: number) => (
                      <Link key={index} className="text-white hover:text-white text-sm mt-2 text-right" to={item?.link}>
                        {item?.name}
                      </Link>
                    ))}
                </ul>
              </ItemNavMobile>
            </li>

            <li className="w-full flex justify-end items-center text-white">
              {!id && !code && (
                <CountriesSelect isDark={isDark} countries={countries} />
              )}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
